import { ProductSlugs } from '@deque/billing-utils';

// Entitlement wire keys grouped by product (must match the backend literals in
// service/src/lib/entitlements.ts).
//
// TECH DEBT: this map ought to live in @deque/billing-utils so backend and
// frontend share one definition instead of mirroring it by hand.
// Tracked in https://github.com/dequelabs/billing-service/issues/2543.
export const PRODUCT_ENTITLEMENTS = {
  [ProductSlugs.axeMonitor]: {
    mcpWrite: 'mcp-write'
  }
} as const;
